import Vue from 'vue';
import Router from 'vue-router';
import Login from '@/views/Login';
// import Dashboard from '@/views/Dashboard'
import Layout from '@/views/Layout';
import PreviewLayout from '@/views/PreviewLayout';
import store from '../store';

Vue.use(Router);

// const ifNotAuthenticated = (to, from, next) => {
//   if (!store.getters.isAuthenticated) {
//     next()
//     return
//   }
//   next('/dashboard')
// }
// this.$router.beforeEach((to, from, next) => {
//   if (!to.matched.length) {
//     next('/notFound')
//   } else {
//     next()
//   }
// })

const ifNotAuthenticated = (to, from, next) => {
  const authUser = store.state.data.tokenData;
  if (authUser && authUser.access_token) {
    next('/dashboard');
    return;
  }
  next();
};

const ifAuthenticated = (to, from, next) => {
  const authUser = store.state.data.tokenData;
  if (
    authUser &&
    authUser.access_token &&
    store.state.data.UserData.id &&
    store.state.data.Translations
  ) {
    next();
  } else if (
    authUser &&
    authUser.access_token &&
    !store.state.data.UserData.id
  ) {
    var url = window.location.pathname.split('/');
    if (typeof url[2] !== 'undefined') {
      var result = url[url.length - 1];
      store.state.data.TicketDetailsId = result;
      store.dispatch('data/getAllTickets').then(() => {
        store.dispatch('data/getTicketDetails');
      });
    }
    // * we need to account_id  in order to call for company details, so we first are waiting for userRequest Response in order to dispatch getCompanyDetails
    store
      .dispatch('data/userRequest')
      .then(() => {
        store.dispatch('data/getCompanyDetails');
      })
      .catch(() => {
        localStorage.removeItem('authUser');
        localStorage.removeItem('authBUser');
        this.$store.state.data.tokenData = '';
        next('/');
      });
    store.dispatch('data/getPages');
    store
      .dispatch('data/getTranslations')
      .then(() => {
        store.dispatch('data/getMenus');
        store.dispatch('data/getEmployees');
        setTimeout(function() {
          next();
        }, 500); // * 1've set a timeout function before redirect in order all data are stored on state before loading route, on page reload.
      })
      .catch(() => {
        localStorage.removeItem('authUser');
        localStorage.removeItem('authBUser');
        this.$store.state.data.tokenData = '';
        next('/');
      });
  } else {
    localStorage.removeItem('authUser');
    localStorage.removeItem('authBUser');
    store.state.data.tokenData = '';
    next('/');
  }
  // store.dispatch('data/getCompanyDetails')
};

export default new Router({
  // mode: process.env.NODE_ENV === 'development' ? 'history' : 'hash',
  mode: 'history',
  // base: '/portal/',
  base: process.env.NODE_ENV === 'development' ? '' : '/portal/',
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login,
      beforeEnter: ifNotAuthenticated
    },
    // {
    //   path: '/dashboard',
    //   name: 'Dashboard',
    //   component: Dashboard
    // },
    {
      path: '/error',
      component: Layout,
      redirect: '/error',
      beforeEnter: ifAuthenticated,
      children: [
        {
          path: '/error',
          component: () => import('@/views/errorPage/404.vue'),
          name: 'error',
          meta: { title: 'error', icon: 'notFound', noCache: true }
        }
      ]
    },
    { path: '*', redirect: '/error', hidden: true },
    {
      path: '/dashboard',
      component: Layout,
      redirect: '/dashboard',
      beforeEnter: ifAuthenticated,
      children: [
        {
          path: '/dashboard',
          component: () => import('@/views/Dashboard'),
          name: 'dashboard',
          meta: { title: 'dashboard', icon: 'dashboard', noCache: true }
        }
      ]
    },
    // {
    //   path: '/files',
    //   component: Layout,
    //   redirect: '/files',
    //   beforeEnter: ifAuthenticated,
    //   children: [
    //     {
    //       path: '/files',
    //       component: () => import('@/views/Files'),
    //       name: 'files',
    //       meta: { from: 'files', title: 'files', icon: 'files', noCache: true }
    //     }
    //   ]
    // },
    {
      path: '/schedule',
      component: Layout,
      redirect: '/schedule',
      beforeEnter: ifAuthenticated,
      children: [
        {
          path: '/schedule',
          component: () => import('@/views/Schedule'),
          name: 'schedule',
          meta: { title: 'schedule', icon: 'about', noCache: true }
        }
      ]
    },
    {
      path: '/requests',
      component: Layout,
      redirect: '/requests',
      beforeEnter: ifAuthenticated,
      children: [
        {
          path: '/requests',
          component: () => import('@/views/Requests'),
          name: 'requests',
          meta: { title: 'requests', icon: 'about', noCache: true }
        }
      ]
    },
    {
      path: '/about us',
      component: Layout,
      redirect: '/about',
      beforeEnter: ifAuthenticated,
      children: [
        {
          path: '/about',
          component: () => import('@/views/About'),
          name: 'about',
          meta: { title: 'about us', icon: 'about', noCache: true }
        }
      ]
    },
    // {
    //   path: '/subscriptions',
    //   component: Layout,
    //   redirect: '/subscriptions',
    //   beforeEnter: ifAuthenticated,
    //   children: [
    //     {
    //       path: '/subscriptions',
    //       component: () => import('@/views/Subscriptions'),
    //       name: 'subscriptions',
    //       meta: { title: 'subscriptions', icon: 'subscriptions', noCache: true }
    //     }
    //   ]
    // },
    // {
    //   path: '/tasks',
    //   component: Layout,
    //   redirect: '/tasks',
    //   beforeEnter: ifAuthenticated,
    //   children: [
    //     {
    //       path: '/tasks',
    //       component: () => import('@/views/Tasks'),
    //       name: 'tasks',
    //       meta: { title: 'tasks', icon: 'tasks', noCache: true }
    //     }
    //   ]
    // },
    // {
    //   path: '/projects overview',
    //   component: Layout,
    //   redirect: '/projects',
    //   beforeEnter: ifAuthenticated,
    //   children: [
    //     {
    //       path: '/projects',
    //       component: () => import('@/views/ProjectsOverview'),
    //       name: 'projects overview',
    //       meta: { title: 'projects overview', icon: 'projects', noCache: true }
    //     }
    //   ]
    // },
    // {
    //   path: '/api',
    //   component: Layout,
    //   redirect: '/api',
    //   beforeEnter: ifAuthenticated,
    //   children: [
    //     {
    //       path: '/api',
    //       component: () => import('@/views/Api'),
    //       name: 'api',
    //       meta: { title: 'api', icon: 'api', noCache: true }
    //     }
    //   ]
    // },
    // {
    //   path: '/calendar',
    //   component: Layout,
    //   redirect: '/calendar',
    //   beforeEnter: ifAuthenticated,
    //   children: [
    //     {
    //       path: '/calendar',
    //       component: () => import('@/components/Calendar/Calendar')
    //     }
    //   ]
    // },
    // {
    //   path: '/upcomingmeetings',
    //   component: Layout,
    //   redirect: '/upcomingmeetings',
    //   beforeEnter: ifAuthenticated,
    //   children: [
    //     {
    //       path: '/upcomingmeetings',
    //       component: () => import('@/components/MeetingsTable/index.vue'),
    //       name: 'Upcoming Meetings',
    //       meta: { title: 'Upcoming Meetings', icon: 'api', noCache: true }
    //     }
    //   ]
    // },
    // {
    //   path: '/upcoming',
    //   component: Layout,
    //   redirect: '/upcoming',
    //   beforeEnter: ifAuthenticated,
    //   children: [
    //     {
    //       path: '/upcoming',
    //       component: () => import('@/components/MeetingsTable/index.vue')
    //     }
    //   ]
    // },
    // {
    //   path: '/allclients',
    //   component: Layout,
    //   redirect: '/allclients',
    //   beforeEnter: ifAuthenticated,
    //   children: [
    //     {
    //       path: '/allclients',
    //       component: () => import('@/components/Tables/GenericTable/index.vue')
    //     }
    //   ]
    // },
    // {
    //   path: '/allproductsandservices',
    //   component: Layout,
    //   redirect: '/allproductsandservices',
    //   beforeEnter: ifAuthenticated,
    //   children: [
    //     {
    //       path: '/allproductsandservices',
    //       component: () => import('@/components/Tables/ProductsTable/index.vue')
    //     }
    //   ]
    // },
    // {
    //   path: '/tickets',
    //   component: Layout,
    //   redirect: '/tickets',
    //   beforeEnter: ifAuthenticated,
    //   children: [
    //     {
    //       path: '/tickets',
    //       component: () => import('@/views/Tickets'),
    //       name: 'tickets'
    //     }
    //   ]
    // },
    // {
    //   path: '/tickets/:id',
    //   component: Layout,
    //   redirect: '/tickets/:id',
    //   beforeEnter: ifAuthenticated,
    //   children: [
    //     {
    //       path: '/tickets/:id',
    //       component: () => import('@/views/TicketDetails'),
    //       name: 'TicketDetails',
    //       meta: { from: 'tickets' }
    //     }
    //   ]
    // },
    // {
    //   path: '/new_ticket',
    //   component: Layout,
    //   redirect: '/new_ticket',
    //   beforeEnter: ifAuthenticated,
    //   children: [
    //     {
    //       path: '/new_ticket',
    //       component: () => import('@/components/Tickets/NewTicket'),
    //       name: 'new_ticket'
    //     }
    //   ]
    // },
    // {
    //   path: '/preview',
    //   component: PreviewLayout,
    //   redirect: '/preview',
    //   beforeEnter: ifAuthenticated,
    //   children: [
    //     {
    //       path: '/preview',
    //       component: () => import('@/components/preview'),
    //       name: 'preview'
    //     }
    //   ]
    // },
    // {
    //   path: '/orders',
    //   component: Layout,
    //   redirect: '/orders',
    //   beforeEnter: ifAuthenticated,
    //   children: [
    //     {
    //       path: '/orders',
    //       component: () => import('@/views/Orders'),
    //       name: 'orders'
    //     }
    //   ]
    // },
    // {
    //   path: '/activity',
    //   component: Layout,
    //   redirect: '/activity',
    //   beforeEnter: ifAuthenticated,
    //   children: [
    //     {
    //       path: '/activity',
    //       component: () => import('@/views/Activity'),
    //       name: 'activity'
    //     }
    //   ]
    // },
    // {
    //   path: '/invoices',
    //   component: Layout,
    //   redirect: '/invoices',
    //   beforeEnter: ifAuthenticated,
    //   children: [
    //     {
    //       path: '/invoices',
    //       component: () => import('@/views/Invoices'),
    //       name: 'invoices'
    //     }
    //   ]
    // },
    {
      path: '/users',
      component: Layout,
      redirect: '/users',
      beforeEnter: ifAuthenticated,
      children: [
        {
          path: '/users',
          component: () => import('@/views/Users'),
          name: 'users'
        }
      ]
    },
    // {
    //   path: '/page/:id',
    //   component: Layout,
    //   redirect: '/:id',
    //   beforeEnter: ifAuthenticated,
    //   children: [{
    //     path: '/:id',
    //     component: () => import('@/views/Page'),
    //     name: 'page',
    //     meta: { title: 'page', icon: 'page', noCache: true }
    //   }]
    // }
    {
      path: '/page/:id',
      component: Layout,
      redirect: '/page/:id',
      beforeEnter: ifAuthenticated,
      children: [
        {
          path: '/page/:id',
          component: () => import('@/views/Page'),
          name: 'page'
        }
      ]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js